var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    directives: [
      {
        name: "tooltip",
        rawName: "v-tooltip.right.hover",
        value: _vm.$t(_vm.blockReasonTooltip),
        expression: "$t(blockReasonTooltip)",
        modifiers: { right: true, hover: true }
      }
    ],
    class: _vm.blockReasonClass
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }